import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Label } from './Common/OkoylUI';

const LogsBox = () => {
    const logs = useSelector(state => state.logs);
    const { t } = useTranslation();

    return (
        <div className="okcard okcard-bare" style={{ marginTop: 16, padding: 0 }}>
            <div style={{ padding: '14px 18px 8px' }}>
                <Label color="gold">{t('logsBox.title')}</Label>
            </div>
            <div
                className="oklog"
                style={{
                    margin: '0 18px 18px',
                    minHeight: 180,
                    maxHeight: 320,
                    padding: '16px 18px',
                }}
            >
                <div className="oklog-line" data-kind="lore">
                    {t('logsBox.welcome')}
                </div>
                {logs && logs.map((entry, index) => (
                    <div key={index} className="oklog-line">
                        {typeof entry === 'string' ? entry : entry}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LogsBox;
